import { useState, useEffect, useCallback } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(
        () => {
            // Update debounced value after delay
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);

            // Cancel the timeout if value/delay change or unmount
            return () => {
                clearTimeout(handler);
            };
        },
        [value, delay], // Only re-call effect if value or delay changes
    );

    return debouncedValue;
}

export function useDebounceCallback<T>(
    callback: (value: T) => void,
    delay: number,
): (value: T) => void {
    const debouncedCallback = useCallback(
        (value: T) => {
            const handler = setTimeout(() => {
                callback(value);
            }, delay);

            return () => {
                clearTimeout(handler);
            };
        },
        [callback, delay],
    );

    return debouncedCallback;
}
